import { BasicData } from "./phoenix.basic-data.model";
import { BaseModel } from "../base.model";

export class PhoenixRequestDetails extends BaseModel {
    public sequenceList: Array<number>;
    public basicData: BasicData;
    public overridenDisciplines?:string;
}
